interface QuoteFieldUpdateProps {
  toolCallId: string;
  state: string;
  args: {
    field: string;
    value: string;
    quoteId: string;
  };
  result?: string;
}

const fieldDisplayNames: Record<string, string> = {
  contact_name: "Nombre de contacto",
  contact_email: "Correo electrónico",
  contact_phone: "Teléfono",
  origin_address: "Dirección de origen",
  destination_address: "Dirección de destino",
  origin_latitude: "Latitud de origen",
  origin_longitude: "Longitud de origen",
  destination_latitude: "Latitud de destino",
  destination_longitude: "Longitud de destino",
};

export const QuoteFieldUpdate = ({ state, args }: QuoteFieldUpdateProps) => {
  const fieldName = fieldDisplayNames[args.field] || args.field;
  
  return (
    <div className="flex flex-col gap-1 p-2 rounded-md bg-gray-50">
      <div className="text-sm text-gray-500">
        Actualizando campo de cotización
      </div>
      <div className="flex items-center gap-2">
        <span className="font-medium">{fieldName}:</span>
        <span className="text-blue-600">{args.value}</span>
      </div>
    </div>
  );
};